import classNames from "classnames";
import styles from "./index.module.scss";
import { Col, Row, Button } from 'antd';
import intl from "react-intl-universal";
const Charter = () => {
	return (
		<div className={classNames('container', styles.charterBox)}>
			<Row gutter={70} justify='center'>
				<Col span={12}>
					<div className={styles.leftBox}>
						<span className={styles.titleBox}>{intl.get("About.OUR CHARTER")}</span>
						<div>{intl.get("About.charterDes")}</div>
						<a href={`${process.env.PUBLIC_URL}/file`} target="_blank">
							<Button type="primary" size="large">{intl.get("About.READ THE OGE Alliance CHARTER")}</Button>
						</a>
					</div>
				</Col>
				{/* <Col span={12}>
					<div className={styles.rightBox}>
						<span className={styles.titleBox}>{intl.get("About.USEFUL LINKS")}</span>
						<ul>
							<li>{intl.get("About.Read the introduction to the")} <a href="http://10.101.240.20:7777/" target="_blank">{intl.get("About.global geo-information infrastructure")}</a></li>
						</ul>
					</div>
				</Col> */}
			</Row>
		</div>
	)
}
export default Charter